/*
 * Client bundle entry shim: publishes the per-response CSP nonce emitted by the
 * server (see src/server/views/index.ejs) to webpack's runtime, so that the
 * <script> and <link> tags webpack injects for lazily loaded chunks carry a
 * valid nonce.
 *
 * `__webpack_nonce__` is a webpack build-time identifier that the compiler
 * rewrites to `__webpack_require__.nc`. That rewrite only happens while it is a
 * free identifier, so it cannot be written as `window.__webpack_nonce__`.
 * This shim therefore lives under webpack/, which is where the ESLint config
 * already declares `__webpack_nonce__` as a writable global.
 */
__webpack_nonce__ = window.voltronNonce;
